export enum ERouteStatus {
    PENDING = 0,
    SCHEDULED = 1,
    FINISHED = 2,
}

export enum ERouteFinishedStatusType {
    MANUAL = 1,
    AUTO = 2,
}

export enum ERoutePeriod {
    MORNING = 0,
    AFTERNOON = 1,
}

export enum ERouteGetAllType {
    CUSTOMER = 1,
    SUPPLIER = 2,
    RECIPIENT = 3,
}